var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5999 13.5998C3.2699 13.5998 2.9874 13.4823 2.7524 13.2473C2.5174 13.0123 2.3999 12.7298 2.3999 12.3998V3.5998C2.3999 3.26525 2.51657 2.9788 2.7499 2.74047C2.98324 2.50225 3.26657 2.38869 3.5999 2.3998H9.36657L8.16657 3.5998H3.5999V12.3998H12.3999V7.83314L13.5999 6.63314V12.3998C13.5999 12.7298 13.4824 13.0123 13.2474 13.2473C13.0124 13.4823 12.7299 13.5998 12.3999 13.5998H3.5999ZM6.3999 9.5998V7.04981L12.2999 1.1498C12.4221 1.02758 12.5555 0.938694 12.6999 0.883138C12.8443 0.827582 12.9916 0.799805 13.1416 0.799805C13.3016 0.799805 13.4541 0.827582 13.5991 0.883138C13.7441 0.938694 13.8773 1.02636 13.9989 1.14614L14.8499 1.9998C14.9721 2.12203 15.061 2.25536 15.1166 2.3998C15.1721 2.54425 15.1999 2.69425 15.1999 2.8498C15.1999 3.00536 15.172 3.15586 15.1162 3.30131C15.0605 3.44664 14.9717 3.57947 14.8499 3.6998L8.9499 9.5998H6.3999ZM7.5999 8.39981H8.4499L12.2999 4.5498L11.8832 4.11647L11.4499 3.6998L7.5999 7.54981V8.39981Z",
    fill: "#00BCD4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditSquare);
export default __webpack_public_path__ + "static/media/edit-square.e1e9a37b2503c2d68d8f12c8020fe5ef.svg";
export { ForwardRef as ReactComponent };